module.exports = __webpack_public_path__ + "static/img/Frame 1855.0a54c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1855.png
// module id = DQmE
// module chunks = 12